import apiClient from './apiClient';

// Types mirror backend/modules/g209/models/g209.go. Keep these names and
// primitive types aligned with the actual API/DB columns.
export interface FG160 {
  fg160_01: string;
  fg160_11: string | null;
  fg160_12: string;
  fg160_13: number;
  fg160_14: number;
  fg160_15: string;
  fg160_16: string;
  fg160_17: string;
  fg160_18: string;
  fg160_19: string;
  fg160_20: number;
  fg160_21: number;
  fg160_22: number;
  fg160_221: number;
  fg160_23: number;
  fg160_231: number;
  fg160_24: string;
  fg160_25: number;
  fg160_26: number;
  fg160_27: number;
  fg160_28: number;
  fg160_29: number;
  fg160_30: string;
  fg160_31: number;
  fg160_32: string;
  fg160_33: string;
  fg160_80: string;
  fg160_81: string;
  fg160_82: string;
  fg160_83: string;
  fg160_91: string;
  fg160_92: string | null;
  fg160_93: string;
  details?: FG161[];
  invoices?: FG164[];
}

export interface FG161 {
  fg161_01: string;
  fg161_02: number;
  fg161_11: string;
  fg161_12: string;
  fg161_121: string;
  fg161_13: number;
  fg161_14: number;
  fg161_15: number;
  fg161_16: number;
  fg161_17: number;
  fg161_18: number;
  fg161_19: number;
  fg161_20: number;
  fg161_21: string;
  fg161_22: string;
  fg161_23: number;
  fg161_24: string;
  fg161_25: number;
  fg161_26: string;
  fg161_27: number;
  fg161_28: number;
}

export interface FG164 {
  fg164_01: string;
  fg164_02: number;
  fg164_10: string;
  fg164_11: string | null;
  fg164_12: number;
  fg164_13: number;
  fg164_91: string;
  fg164_92: string | null;
}

export interface ListResponse {
  data: FG160[];
  total: number;
  page: number;
  size: number;
}

export interface CreateRequest {
  master: Partial<FG160>;
  details: Partial<FG161>[];
  invoices?: Partial<FG164>[];
}

export interface ValidationError {
  field: string;
  message: string;
}

export const STATUS_MAP: Record<string, { label: string; color: string }> = {
  A: { label: '草稿', color: 'default' },
  E: { label: '送審中', color: 'blue' },
  P: { label: '業務核准', color: 'green' },
  X: { label: '財務審核中', color: 'orange' },
  Z: { label: '財務核准', color: 'cyan' },
  C: { label: '已結案', color: 'gray' },
};

export const INVOICE_TYPE_MAP: Record<string, string> = {
  F: '檢驗收入',
  G: '預收款',
  H: '代收代付',
  I: '其他應收',
};

export const invoiceRequestApi = {
  async list(page = 1, size = 20, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/invoice-request', { params });
    return res.data;
  },

  async get(reqNo: string): Promise<FG160> {
    const res = await apiClient.get(`/api/invoice-request/${encodeURIComponent(reqNo)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FG160> {
    const res = await apiClient.post('/api/invoice-request', data);
    return res.data;
  },

  async update(reqNo: string, data: CreateRequest): Promise<FG160> {
    const res = await apiClient.put(`/api/invoice-request/${encodeURIComponent(reqNo)}`, data);
    return res.data;
  },

  async delete(reqNo: string): Promise<void> {
    await apiClient.delete(`/api/invoice-request/${encodeURIComponent(reqNo)}`);
  },

  async submit(reqNo: string): Promise<void> {
    await apiClient.post(`/api/invoice-request/${encodeURIComponent(reqNo)}/submit`);
  },

  async approve(reqNo: string): Promise<void> {
    await apiClient.post(`/api/invoice-request/${encodeURIComponent(reqNo)}/approve`);
  },
};
